<template>
    <div class="contacts-wrapper" id="contacts">
        <div class="contacts">
            <div class="title" v-html="$ml.with('VueJS').get('contacts')"></div>
            <div class="contacts-list">

                <div class="contacts-row">
                    <div class="contacts-item">
                        <a href="tel:+78006005513" class="contact-phone"><span>+7 800 600-55-13</span></a>
                    </div>
                    <div class="contacts-item">
                        <a href="mailto:info@ylw.ru.com" class="contact-email"><span>info@ylw.ru.com</span></a>
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>



<script>
    export default {
        name: 'Contacts'
    }
</script>